import { SETTINGS_TYPE } from './SettingsType';

export const SETTINGS = [
  {
    settingType: SETTINGS_TYPE.PROFILE,
    settingName: 'Profile',
    settingDescription: 'Change user details and etc.'
  },
  {
    settingType: SETTINGS_TYPE.BUSINESS,
    settingName: 'Business',
    settingDescription: 'Change user details and etc.'
  },
  {
    settingType: SETTINGS_TYPE.TEAM,
    settingName: 'Team',
    settingDescription: 'Change user details and etc.'
  },
  {
    settingType: SETTINGS_TYPE.PAYMENT_METHOD,
    settingName: 'Payment method',
    settingDescription: 'Change user details and etc.'
  }
  // {
  //   settingType: SETTINGS_TYPE.INTEGRATION,
  //   settingName: 'Integration',
  //   settingDescription: 'Change user details and etc.'
  // }
];
